// src/components/Board/PostDetail.js
import React, { useEffect, useState } from "react";
import { fetchPostDetail, deletePost } from "../../api/boardApi";
import { useAuth } from "../../context/AuthContext";

const PostDetail = ({ postId, boardSlug, onClose, onDeleted }) => {
  const [post, setPost] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await fetchPostDetail(boardSlug, postId); // ✅ boardSlug 포함 요청
        setPost(res.data);
      } catch (err) {
        console.error("❌ 게시물 조회 실패", err);
        alert("게시글을 불러오지 못했습니다.");
        onClose();
      }
    };
    fetch();
  }, [postId, boardSlug, onClose]); // ✅ boardSlug 의존성 포함

  const handleDelete = async () => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    try {
      await deletePost(boardSlug, postId); // ✅ boardSlug 포함
      alert("✅ 삭제되었습니다.");
      onDeleted();
      onClose();
    } catch (err) {
      console.error("❌ 삭제 실패", err);
      alert("삭제에 실패했습니다.");
    }
  };

  if (!post) return null;

  const isAuthor = user?.email === post.author_name;

  return (
    <div className="p-4 border rounded shadow bg-white">
      <h2 className="text-xl font-bold mb-2">{post.title}</h2>
      <p className="text-gray-600 mb-1">작성자: {post.author_name}</p>
      <p className="text-gray-500 text-sm mb-4">
        작성일: {new Date(post.created_at).toLocaleString()}
      </p>

      <div className="whitespace-pre-wrap border-t pt-4">{post.content}</div>

      <div className="mt-6 flex justify-end gap-2">
        <button
          onClick={onClose}
          className="px-4 py-1 bg-gray-300 text-black rounded"
        >
          닫기
        </button>
        {isAuthor && (
          <button
            onClick={handleDelete}
            className="px-4 py-1 bg-red-500 text-white rounded"
          >
            삭제
          </button>
        )}
      </div>
    </div>
  );
};

export default PostDetail;
